<template>
    <div v-cloak class="dynamic-island-header">
        <nav class="navbar mt-7 -mb-6 navbar-online-booking" v-if="showNavigation">
            <div>
                <!-- Toggle get grouped for better mobile display -->
                <div class="navbar-header">
                    <button
                        type="button"
                        class="navbar-toggle flex bg-white rounded-lg shadow items-center gap-x-3 mt-0 hidden-sm hidden-md hidden-lg hidden-xl text-brand-primary"
                        data-toggle="collapse"
                        data-target="#iframe-navigation"
                        aria-expanded="false"
                    >
                        <i class="fas fa-bars"></i>
                        <span>{{ trans('online_booking.menu') }}</span>
                    </button>
                </div>

                <!-- Collect the nav links for toggling -->
                <div class="navbar-collapse pb-4 sm:z-1 absolute z-10 right-0 left-0 collapse" id="iframe-navigation">
                    <div class="flex sm:justify-center justify-end">
                        <ul class="nav navbar-nav sm:rounded-full border-4 border-white bg-white border-solid shadow flex-column sm:flex-row flex rounded-lg">
                            <li
                                v-for="item in navigationItems"
                                :key="item.id"
                                :class="{'active': item.isNavActive}"
                            >
                                <router-link
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.in"
                                    exact-path
                                    :to="navigationLink(item)"
                                    class="sm:rounded-full rounded"
                                >
                                    {{ item.name }}
                                    <span
                                        v-if="item.routeName === 'secure-messages' && unreadMessages"
                                        class="unread-message-alert"
                                    >
                                        {{ unreadMessages }}
                                    </span>
                                </router-link>
                            </li>
                            <li v-if="isClientLoggedIn">
                                <a
                                    class="sm:rounded-full rounded cursor-pointer text-sm"
                                    @click="$emit('logout')"
                                >
                                    <i class="fas fa-sign-out-alt"></i>
                                    <span class="hidden-sm hidden-md hidden-lg hidden-xl">{{ trans('online_booking.logout') }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import currentRoute from '@/online_booking/new/mixins/currentRoute';
export default {
    props: {
        isClientLoggedIn: {
            type: Boolean,
            default: false
        },
        isClientLoginActive: {
            type: Boolean,
            default: false
        },
        isEventsActive: {
            type: Boolean,
            default: false
        },
        isGiftcardsActive: {
            type: Boolean,
            default: false
        },
        isMessagingActive: {
            type: Boolean,
            default: false
        },
        isOnlineBookingActive: {
            type: Boolean,
            default: false
        },
        isOnlineCoursesActive: {
            type: Boolean,
            default: false
        },
        isVouchersActive: {
            type: Boolean,
            default: false
        },
        isSubscriptionsActive : {
            type: Boolean,
            default: false
        },
        unreadMessages : {
            type: Number,
            default: 0
        },
        eventOverviewSlug: {
            type: String,
            default: ''
        },
    },

    computed: {
        navigationItems () {
            const items = [
                {
                    name: this.trans('online_booking.book_time'),
                    routeName: 'online-booking',
                    enabled: this.isOnlineBookingActive,
                    isNavActive: this.$route.name === 'online-booking',
                },
                {
                    name: this.trans('events.event_app_name'),
                    routeName: 'events',
                    params: { slug: this.eventOverviewSlug },
                    enabled: this.isEventsActive,
                    isNavActive: this.isEventsFlow,
                },
                {
                    name: this.trans('apps.online_courses.name'),
                    routeName: 'online-courses',
                    params: { slug: this.eventOverviewSlug },
                    enabled: this.isOnlineCoursesActive,
                    isNavActive: this.isCoursesFlow,
                },
                {
                    name: this.trans('vouchers.public_link_title'),
                    routeName: 'buy-vouchers',
                    enabled: this.isVouchersActive,
                    isNavActive: this.$route.name === 'buy-vouchers',
                },
                {
                    name: this.trans('giftcards.purchasing.public_link_title'),
                    routeName: 'buy-giftcards',
                    enabled: this.isGiftcardsActive,
                    isNavActive: this.$route.name === 'buy-giftcards',
                },
                {
                    name: this.trans('online_booking.messages'),
                    routeName: 'secure-messages',
                    enabled: this.isMessagingActive,
                    isNavActive: this.$route.name === 'secure-messages',
                },
                {
                    name: this.trans('apps.memberships.name'),
                    routeName: 'memberships',
                    params: { slug: this.eventOverviewSlug },
                    enabled: this.isSubscriptionsActive,
                    isNavActive: this.isMembershipsFlow,
                },
                {
                    name: this.trans('online_booking.your_page'),
                    routeName: 'your-page',
                    enabled: this.isClientLoggedIn,
                    isNavActive: this.$route.name === 'your-page',
                },
                {
                    name: this.trans('online_booking.login'),
                    routeName: 'client-login',
                    enabled: this.isClientLoginActive && !this.isClientLoggedIn,
                    isNavActive: this.$route.name === 'client-login',
                },
            ];
            return items.filter(item => item.enabled);
        },

        showNavigation () {
            return this.navigationItems.filter(item => item.enabled).length > 1 || this.isClientLoginActive;
        },
    },

    methods: {
        navigationLink (item) {
            if (item.params) {
                return { name: item.routeName, params: item.params };
            }
            return { name: item.routeName };
        },
    },

    mixins: [currentRoute],
}
</script>
